module.exports = __webpack_public_path__ + "media/images/lipo-55e98ba2be673bbffc476737cd2a3092.png";